<template>
  <!-- 新增、修改  :visible.sync="dialogVisible"-->
  <el-dialog class="edit-integral" :title="dialogTitle" v-bind="$attrs" width="900px" @before-close="handleClose" @close="handleClose">
    <el-form :model="form" label-width="140px" :rules="rules" ref="form" inline>
      <el-form-item label="积分名称" prop="name" style="width: 400px">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="积分持续天数" prop="duration" style="width: 400px">
        <el-input v-model.number="form.duration"></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="desc" style="width: 400px">
        <el-input type="textarea" :rows="5" v-model="form.desc"></el-input>
      </el-form-item>
      <el-form-item label="积分价格" prop="price" style="width: 400px">
        <el-input v-model.number="form.price"></el-input>
      </el-form-item>
      <el-form-item label="积分价值" prop="equivalentPrice" style="width: 400px">
        <el-input v-model.number="form.equivalentPrice"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type" style="width: 400px">
        <el-select v-model="form.type">
          <el-option :label="item.label" :value="item.value" v-for="item in types" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="奖品配置" prop="type" style="width: 800px">
        <el-row style="width: 630px; margin-bottom: 10px;" :gutter="10" v-for="(prize, i) in prizes" :key="i">
          <el-col :span="12">
            <el-select v-model="prize.prizes" placeholder="请选择奖品" @click.native="queryPrizeBox" multiple>
              <el-option :label="item.label" :value="item.value" v-for="item in prizeBox" :key="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-input-number v-model="prize.finishCondition" :min="0" :max="100" placeholder="权重"></el-input-number>
          </el-col>
          <el-col :span="2">
            <el-button type="danger" circle icon="el-icon-delete" @click="delPrize(i)"></el-button>
          </el-col>
          <el-col :span="2">
            <el-button v-show="i === prizes.length - 1" type="success" :disabled="!isLastInputDone" circle icon="el-icon-circle-plus" @click="addPrize"></el-button>
          </el-col>
        </el-row>
        <el-button v-if="!prizes.length" size="normal" type="primary" @click="addPrize">添加奖品配置</el-button>
      </el-form-item>
      <el-form-item label="图标:" prop="cover" style="width: 400px">
        <base-upload class="upload" :cover="form.img" :action="action" wSize="47" hSize="47" :width="'138.5px'"
          :height="'138.5px'" @successCallback="handleAvatarSuccess"></base-upload>
      </el-form-item>
      <el-form-item label="状态" prop="status" style="width: 400px">
        <el-select v-model="form.status">
          <el-option :label="item.label" :value="item.value" v-for="item in statuses" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="status" style="width: 400px">
        <el-input-number v-model="form.sortCode" placeholder="排序"></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="onSubmit()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import API from "@/api";
import { integralPrizeTypes, statuses } from '../../../../config';

export default {
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      rules: {
        name: [{ required: true, message: "请输入积分名称", trigger: "blur" }],
        duration: [
          { required: true, message: "请输入积分持续天数", trigger: "blur" },
        ],
        price: [{ required: true, message: "请输入积分价格", trigger: "blur" }],
        equivalentPrice: [
          { required: true, message: "请输入积分价值", trigger: "blur" },
        ],
      },
      prizes: [],
      statuses,
      types: integralPrizeTypes,
      prizeBox: []
    }
  },
  watch: {
    form: {
      handler(val) {
        if (val && val.detail) {
          this.queryPrizeBox()
          this.prizes = val.detail
        } else {
          this.prizes = []
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    isLastInputDone() {
      if (this.prizes.length < 1) return true
      const lastPrize = this.prizes[this.prizes.length - 1]
      return lastPrize.prizes.length && lastPrize.finishCondition
    }
  },
  methods: {
    queryPrizeBox() {
      if (this.prizeBox.length) return
      API.queryPrizeBox()
        .then((res) => {
          if (res.code === 200 && res.data.length > 0) {
            this.prizeBox = res.data;
            return;
          }
          this.$message.error(res.msg || "获取奖品失败");
          this.prizeBox = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    addPrize() {
      if (!this.isLastInputDone) {
        return
      }
      const emptyPrize = {
        prizes: [],
        finishCondition: null
      }
      this.prizes.push(emptyPrize)
    },
    delPrize(idx) {
      this.prizes.splice(idx, 1)
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    handleAvatarSuccess(res) {
      // 标签封面上传成功回掉
      this.form.img = res.data.coverImg;
    },
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (!this.isLastInputDone) {
            this.prizes.pop()
          }
          this.$emit('submit', this.prizes)
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-integral {
  /deep/ .el-form-item__content {
    width: 200px;
  }
}
</style>